import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CarRentalPackageService from "../../services/carrentalpackage.service";

// **Async Thunks**
export const getcarrentalPackageList = createAsyncThunk(
  "carrentalPackage/getcarrentalPackageList",
  async (item, thunkApi) => {
    try {
      const response = await CarRentalPackageService.getcarrentalPackageList(item);
      return response.data || []; 
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const postcarrentalPackage = createAsyncThunk(
  "carrentalPackage/postcarrentalPackage",
  async (item, thunkAPI) => {
    try {
      const response = await CarRentalPackageService.addcarrentalPackage(item);
      return response.data || response.data; 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const putcarrentalPackage = createAsyncThunk(
  "carrentalPackage/putcarrentalPackage",
  async (item, thunkAPI) => {
    try {
      const response = await CarRentalPackageService.editcarrentalPackage(item);
      return response.data || response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletecarrentalPackage = createAsyncThunk(
  "carrentalPackage/deletecarrentalPackage",
  async (id, thunkAPI) => {
    try {
      await CarRentalPackageService.deletecarrentalPackage(id);
      return id; // ✅ Return only the ID for state update
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  carrentalPackages: [],
};

// **Slice**
const carrentalPackageSlice = createSlice({
  name: "carrentalPackage",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Car Rental Package List**
      .addCase(getcarrentalPackageList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getcarrentalPackageList.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = action.payload;
      })
      .addCase(getcarrentalPackageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Car Rental Package**
      .addCase(postcarrentalPackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(postcarrentalPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages.push(action.payload);
      })
      .addCase(postcarrentalPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Car Rental Package**
      .addCase(putcarrentalPackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(putcarrentalPackage.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.carrentalPackages.findIndex((p) => p._id === action.payload._id); // ✅ Handle `_id` correctly
        if (index !== -1) {
          state.carrentalPackages[index] = action.payload;
        }
      })
      .addCase(putcarrentalPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Car Rental Package**
      .addCase(deletecarrentalPackage.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletecarrentalPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.carrentalPackages = state.carrentalPackages.filter((p) => p._id !== action.payload); // ✅ Handle `_id`
      })
      .addCase(deletecarrentalPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default carrentalPackageSlice.reducer;
